import React from "react";
import Layout from "../Layout/Layout";

const AboutUs = () => {
  return (
    <Layout>
      <h2>this is aboutus </h2>
    </Layout>
  );
};

export default AboutUs;
